import React from 'react';

const VrbexContext = React.createContext({});

export const VrbexProvider = VrbexContext.Provider;
export const VrbexConsumer = VrbexContext.Consumer;

export default VrbexContext;
